module.exports = __webpack_public_path__ + "img/logo.db538a80.png";